<template>
  <div>
    <div class="container mb-48">
      <div class="bg-gray rounded-t-md shadow relative z-50 mt-2 py-1 pb-4 sm:pb-8 rounded-b-md">
        <div class="text-center relative">
          <h2 class="mt-5 text-sm sm:text-2xl font-semibold uppercase text-primary">
            {{ $t('delete.confirm') }}
          </h2>
          <button
            type="button"
            class="btn h-14 px-9 flex items-center"
            style="margin: 0 auto; margin-top: 15px;"
            @click="deleteAccount"
          >
            {{ $t('delete.action') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'DeleteAccount',
  methods: {
    deleteAccount() {
      window.location.href = `${process.env.VUE_APP_API_URL}/delete/${this.$route.params.token}`;
    },
  },
};
</script>
